import { useRootStore } from "~/store/root"

export default defineNuxtPlugin(({ $pinia }) => {
    useRootStore($pinia).setAnonymousId()
})
